<div class="cb-wrap">
  <h3 class="cb-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="color-blindness">
    <!-- The swatch IS the colour picker: click it to choose a colour. -->
    <div class="cb-head">
      <input class="cb-swatch"
             type="color"
             [value]="swatch"
             (input)="onPicker($any($event.target).value)"
             aria-label="Pick a base color">
      <div class="cb-input-wrap">
        <label class="cb-label" for="cb-hex">Pick a Color</label>
        <input id="cb-hex"
               class="cb-text"
               type="text"
               autocomplete="off"
               spellcheck="false"
               maxlength="7"
               inputmode="latin"
               [value]="text"
               (input)="onText($any($event.target).value)"
               (keydown)="onKey($event)"
               aria-label="Base hex color code">
      </div>
    </div>

    <!-- One sub-group per cone family; each type pairs the real colour (left) with
         the simulated colour (right) in a two-box chip, the name and a note beside. -->
    <div class="cb-groups">
      <div class="cb-group" *ngFor="let g of groups">
        <span class="cb-group-label">{{ g.group }}</span>

        <div class="cb-item" *ngFor="let t of g.types">
          <div class="cb-swatch-col">
            <span class="cb-chip">
              <button type="button" class="cb-seg cb-orig" [style.background]="hex"
                      (click)="copy( hex, t.key + '-o' )" [attr.aria-label]="'Copy ' + hex"></button>
              <button type="button" class="cb-seg cb-sim" [style.background]="simFor( t )"
                      (click)="copy( simFor( t ), t.key + '-s' )" [attr.aria-label]="'Copy ' + simFor( t )"></button>
            </span>
            <span class="cb-hexes">
              <span class="cb-hex">{{ copiedKey === t.key + '-o' ? 'Copied' : hex }}</span>
              <span class="cb-hex">{{ copiedKey === t.key + '-s' ? 'Copied' : simFor( t ) }}</span>
            </span>
          </div>
          <div class="cb-info">
            <span class="cb-name">{{ t.title }}</span>
            <span class="cb-note">{{ t.note }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
